import "magnific-popup";
import HistoryHelper from "../helper/history.jsx";
import initSpellChecker from "./email-spell-checker.js";

$(".popup-youtube").magnificPopup({
  key: "youtube",
  type: "iframe",
});

$(".external-booking-link").magnificPopup({
  type: "iframe",
  key: "booking",
});
$(".external-iframe-link").magnificPopup({
  type: "iframe",
  key: "iframe",
});

if ($("#fraud_protection").length) {
  jQuery.magnificPopup.open(
    {
      items: { src: "#fraud_protection" },
      closeOnBgClick: false,
      closeBtnInside: true,
      type: "inline",
    },
    0
  );
}

$(".popup-booking").magnificPopup({
  type: "ajax",
  ajax: {
    settings: {
      type: "POST",
    },
  },
  //        disableOn: 480,
  // delegate: 'button',
  closeOnBgClick: false,
  closeBtnInside: true,
  fixedContentPos: true,
  callbacks: {
    parseAjax: function (mfpResponse) {
      mfpResponse.data = $(mfpResponse.data).find("#booking");
      $(mfpResponse.data).find("form").removeAttr("novalidate");
      // $(mfpResponse.data).find('.recaptcha-container').remove();
    },
    ajaxContentAdded: function () {
      $(".mfp-preloader").remove();
      HistoryHelper.loadBookingData("#booking");
      window.initBookingForm();
      initSpellChecker();

      $(document).one("click", ".mfp-ajax-holder #form_close", function (e) {
        e.preventDefault();
        let magnificPopup = $.magnificPopup.instance;
        magnificPopup.close();
      });
    },
    close: function () {
      window.initFlatpickr();
      HistoryHelper.setBookingItemInfo();
    },
  },
});

$(".popup-booking-alternative").magnificPopup({
  type: "ajax",
  ajax: {
    settings: {
      type: "POST",
    },
  },
  closeOnBgClick: false,
  closeBtnInside: true,
});

$(".popup-dsa").magnificPopup({
  type: "ajax",
  ajax: {
    settings: {
      type: "POST",
    },
  },
  closeOnBgClick: false,
  closeBtnInside: true,
  fixedContentPos: true,
  callbacks: {
    parseAjax: function (mfpResponse) {
      mfpResponse.data = $(mfpResponse.data).find("#dsa-report");
      $(mfpResponse.data).find("form").removeAttr("novalidate");
    },
    ajaxContentAdded: function () {
      $(".mfp-preloader").remove();

      $(document).one(
        "click",
        ".mfp-ajax-holder #form_close, .mfp-ajax-holder #dsa-confirm-box",
        function (e) {
          e.preventDefault();
          let magnificPopup = $.magnificPopup.instance;
          magnificPopup.close();
        }
      );

      $(document).off("submit", "#dsa-report form");

      $(document).on("submit", "#dsa-report form", function (e) {
        e.preventDefault();

        let form = $(this);
        let formData = form.serialize();

        let actionUrl = $.magnificPopup.instance.currItem.src;
        form.attr("action", actionUrl);

        $.ajax({
          type: "POST",
          url: form.attr("action"),
          data: formData,
          success: function (response) {
            let magnificPopup = $.magnificPopup.instance;
            magnificPopup.content.html($(response).find("#dsa-report").html());
          },
        });
      });
    },
    close: function () {
      window.initFlatpickr();
    },
  },
});

$(".popup-page").magnificPopup({
  type: "ajax",
  //        disableOn: 480,
  closeOnBgClick: true,
  closeBtnInside: true,
  callbacks: {
    parseAjax: function (mfpResponse) {
      var $contentData = $(mfpResponse.data);
      $contentData.find("form").removeAttr("novalidate");
      $contentData.find(".load-map").remove();

      if ($contentData.find("#insights").length > 0) {
        $contentData.find("#insights svg.icon").remove();
        $contentData.find("#addressForm > div:first-child").remove();
        $contentData.find("#activity .show-actions").remove();
        $contentData.find("#top-entry .col-lg-6").removeClass("col-lg-6");
        $contentData
          .find("#addressForm > div:last-child")
          .removeClass("col-md-6");
        $contentData.find(".map").parent().remove();
        $contentData = $(
          '<div class="w ps-4 pe-4 pt-1 pb-1 sctn bg clr3 mt-5">'
        ).html($contentData.find("#insights"));
      }
      if ($contentData.find("#cities").length > 0) {
        $contentData = $('<div class="w">').html(
          $('<div class="pd sctn bg clr3">').html($contentData.find("#cities"))
        );
      }
      if ($contentData.find("#contract").length > 0) {
        $contentData = $contentData.find("#contract");
      }
      if ($contentData.find("#review-list").length > 0) {
        $contentData = $contentData.find("#review-list");
      }
      if ($contentData.find("#review").length > 0) {
        $contentData = $contentData.find("#review");
      }
      if ($contentData.find("#pricing").length > 0) {
        $contentData = $('<div id="static" class="relative w pe-0 ps-0">').html(
          $('<div class="w pd sctn white">')
            .html($contentData.find("#pricing"))
            .prepend($contentData.find("h1"))
        );
      }
      mfpResponse.data = $contentData;
      $(".mfp-preloader").remove();
    },
  },
});

$(".popup-image").magnificPopup({
  type: "image",
  // closeOnBgClick: false,
  preloader: false,
  mainClass: "mfp-fade",
});

$(".popup-gallery").each(function () {
  $(this).magnificPopup({
    type: "image",
    delegate: ".item",
    zoom: {
      enabled: true,
      easing: "ease-in-out",
      opener: function (openerElement) {
        return openerElement;
      },
    },
    gallery: {
      enabled: true,
      arrowMarkup:
        '<button type="button" class="mfp-%dir% mfp-arrow  mfp-prevent-close"><svg class="icon mfp-prevent-close" width="30" height="30"><use href="#arrow-%dir%" class="mfp-prevent-close"></use></svg></button>',
    },
  });
});

// $(".popup-gallery").magnificPopup({
//   type: "image",
//   delegate: ".item",
//   zoom: {
//     enabled: true,
//     easing: "ease-in-out",
//     opener: function (openerElement) {
//       return openerElement;
//     },
//   },
//   gallery: {
//     enabled: true,
//     arrowMarkup:
//       '<button type="button" class="mfp-%dir% mfp-arrow  mfp-prevent-close"><svg class="icon mfp-prevent-close" width="30" height="30"><use href="#arrow-%dir%" class="mfp-prevent-close"></use></svg></button>',
//   },
// });

if ($("#static .highlights").length) {
  $("#static .highlights").magnificPopup({
    delegate: ".t",
    type: "image",
    // closeOnBgClick: false,
    image: {
      titleSrc: function (item) {
        return $("<div>").html(item.el.data("caption")).text();
      },
    },
    preloader: false,
    zoom: {
      enabled: true,
      easing: "ease-in-out",
      opener: function (openerElement) {
        return openerElement;
      },
    },
    gallery: {
      enabled: true,
      arrowMarkup:
        '<button type="button" class="mfp-%dir% mfp-arrow  mfp-prevent-close"><svg class="icon mfp-prevent-close" width="30" height="30"><use href="#arrow-%dir%" class="mfp-prevent-close"></use></svg></button>',
    },
  });
}

let imagePopupOptions = {
  delegate: ".item",
  type: "image",
  // closeOnBgClick: false,
  image: {
    titleSrc: function (item) {
      return $("<div>").html(item.el.data("caption")).text();
    },
  },
  preloader: false,
  zoom: {
    enabled: true,
    easing: "ease-in-out",
    opener: function (openerElement) {
      if (window.$wrapper.width() < 1024 && gallerySlider.length) {
        return gallerySlider;
      }
      return openerElement.is("img")
        ? openerElement
        : openerElement.find("img");
    },
  },
  gallery: {
    enabled: true,
    arrowMarkup:
      '<button type="button" class="mfp-%dir% mfp-arrow  mfp-prevent-close"><svg class="icon mfp-prevent-close" width="30" height="30"><use href="#arrow-%dir%" class="mfp-prevent-close"></use></svg></button>',
  },
  callbacks: {
    change: function () {
      if (
        gallerySlider.length &&
        !handheld &&
        typeof gallerySlider.slick !== "undefined"
      ) {
        gallerySlider.slick("slickGoTo", this.index);
      }
    },
    open: function (event) {
      // Will fire when this exact popup is opened
      // this - is Magnific Popup object

      if (typeof $.fn.swipe === "function") {
        var magnificPopup = $.magnificPopup.instance;

        $(".mfp-container").swipe({
          swipeLeft: function (
            event,
            direction,
            distance,
            duration,
            fingerCount
          ) {
            magnificPopup.next();
          },
          swipeRight: function () {
            magnificPopup.prev();
          },
          threshold: 50,
        });
      } else {
        //  $(".mfp-container").swipe('destroy');
      }
    },
    close: function () {
      // Will fire when popup is closed
    },
  },
};

// let gallerySlider = $('.slider.type-gallery .items')
// if (!window.handheld) {
//     let desktopThumbnails = $('.mobile-hidden.popup-images').magnificPopup(imagePopupOptions);
//     $('.popup-thumbnails').on('click', '.item', function(e) {
//         desktopThumbnails.magnificPopup('open', $(this).data('index'));
//     })
// } else {
//     if (!gallerySlider.length) {
//         gallerySlider = $('.popup-gallery .items')
//     }
//     gallerySlider.magnificPopup(imagePopupOptions)
//     $('.zoom-trigger').on('click', function(e) {
//         e.preventDefault();
//         gallerySlider.magnificPopup('open', 0);
//     })
// }

let gallerySlider = $(".slider.type-gallery .items");
if (!window.handheld) {
  let visibleThumbnails = $(".popup-images:visible").magnificPopup(
    imagePopupOptions
  );
  $(".popup-thumbnails").on("click", ".item", function (e) {
    if ($(".thumbnails").length > 0) {
      $(".thumbnails").magnificPopup("open", $(this).data("index"));
    }
  });
} else {
  gallerySlider = $("#rental .images");
  gallerySlider.magnificPopup(imagePopupOptions);
  $(".zoom-trigger").on("click", function (e) {
    e.preventDefault();
    gallerySlider.magnificPopup("open", 0);
  });
}
